export enum DeviceTypes {
    BROWSER = 'browser',
    MOBILE = 'mobile',
    TABLET = 'tablet'
}

